var render = function render(){var _vm=this,_c=_vm._self._c;return _c('radio-selection',_vm._b({attrs:{"title":_vm.$options.SELECTION_TITLE,"options":_vm.$options.SELECTION_METHODS,"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}},'radio-selection',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }